import { Spin, BackTop } from 'antd';

import classNames from 'classnames';

import parse from 'html-react-parser';
import months from '../../Shared/months.json';
import useQuery from '../../../../util/useQuery';
// import RecruitmentPolicyService from '../../../../services/RecruitmentPolicy.service';

export default function PreviewArticle({ lang, detail, mode, loading, logo }) {
    const params = useQuery();
    const recruitmentPrivacyPolicy = detail?.recruitmentPrivacyPolicy;
    const recruitmentIntroductionLawfulBasis =
        detail?.recruitmentIntroductionLawfulBasis;
    const recruitmentPersonalDataCollect =
        detail?.recruitmentPersonalDataCollect;
    const recruitmentReasonCollectedData =
        detail?.recruitmentReasonCollectedData;
    const recruitmentTransferPersonalData =
        detail?.recruitmentTransferPersonalData;
    const recruitmentRetainPersonalData = detail?.recruitmentRetainPersonalData;
    const recruitmentDataSubjectRight = detail?.recruitmentDataSubjectRight;
    const recruitmentPolicyChange = detail?.recruitmentPolicyChange;

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'TH' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'TH' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const updateDate = date?.split(' ')[0];
        const dateItem = `${updateDate?.split('/')[1]}/${
            updateDate?.split('/')[0]
        }/${updateDate?.split('/')[2]}`;
        const currentDate = new Date(dateItem);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    return (
        <Spin spinning={loading}>
            <div
                className={classNames({
                    'rounded-md py-4 pl-4 pr-2 w-full border-1 max-w-4xl my-4 mx-auto bg-white':
                        !params.get('ember'),
                    'm-0 w-full !border-none ': params.get('ember') === '1',
                })}
                style={{ border: '1px solid #DBDBDB' }}
            >
                <div>
                    <div className="px-2">
                        <article className="prose max-w-full text-left">
                            <div className="text-center">
                                {recruitmentPrivacyPolicy?.recruitmentCompanyLogoId && (
                                    <img
                                        className="w-auto h-28 rounded-lg object-cover m-0"
                                        src={logo}
                                        alt={
                                            lang === 'TH'
                                                ? recruitmentPrivacyPolicy?.recruitmentCompanyNameTh
                                                : recruitmentPrivacyPolicy?.recruitmentCompanyNameEn
                                        }
                                    />
                                )}
                                <h3>
                                    {lang === 'TH'
                                        ? recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyNameTh
                                        : recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyNameEn}
                                </h3>
                                <p className="text-left">
                                    {recruitmentIntroductionLawfulBasis?.recruitmentIntroductionIsDisplay ===
                                    true ? (
                                        lang === 'TH' ? (
                                            parse(
                                                recruitmentIntroductionLawfulBasis?.recruitmentIntroductionContentTh ||
                                                    '-'
                                            )
                                        ) : (
                                            parse(
                                                recruitmentIntroductionLawfulBasis?.recruitmentIntroductionContentEn ||
                                                    '-'
                                            )
                                        )
                                    ) : (
                                        <></>
                                    )}
                                </p>
                            </div>
                            <h4>
                                {recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisTitleTh
                                    ) : (
                                        recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentPersonalDataCollect?.recruitmentPersonalDataIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentPersonalDataCollect?.recruitmentPersonalDataTitleTh
                                    ) : (
                                        recruitmentPersonalDataCollect?.recruitmentPersonalDataTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentPersonalDataCollect?.recruitmentPersonalDataIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentPersonalDataCollect?.recruitmentPersonalDataContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentPersonalDataCollect?.recruitmentPersonalDataContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentPersonalDataCollect?.recruitmentSourceIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentPersonalDataCollect?.recruitmentSourceTitleTh
                                    ) : (
                                        recruitmentPersonalDataCollect?.recruitmentSourceTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentPersonalDataCollect?.recruitmentSourceIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentPersonalDataCollect?.recruitmentSourceContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentPersonalDataCollect?.recruitmentSourceContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentReasonCollectedData?.recruitmentPurposeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentReasonCollectedData?.recruitmentPurposeTitleTh
                                    ) : (
                                        recruitmentReasonCollectedData?.recruitmentPurposeTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentReasonCollectedData?.recruitmentPurposeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentReasonCollectedData?.recruitmentPurposeContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentReasonCollectedData?.recruitmentPurposeContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentTransferPersonalData?.recruitmentDisclosureIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentTransferPersonalData?.recruitmentDisclosureTitleTh
                                    ) : (
                                        recruitmentTransferPersonalData?.recruitmentDisclosureTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentTransferPersonalData?.recruitmentDisclosureIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentTransferPersonalData?.recruitmentDisclosureContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentTransferPersonalData?.recruitmentDisclosureContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentTransferPersonalData?.recruitmentInternationalIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentTransferPersonalData?.recruitmentInternationalTitleTh
                                    ) : (
                                        recruitmentTransferPersonalData?.recruitmentInternationalTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentTransferPersonalData?.recruitmentInternationalIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentTransferPersonalData?.recruitmentInternationalContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentTransferPersonalData?.recruitmentInternationalContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentRetainPersonalData?.recruitmentRetentionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentRetainPersonalData?.recruitmentRetentionTitleTh
                                    ) : (
                                        recruitmentRetainPersonalData?.recruitmentRetentionTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentRetainPersonalData?.recruitmentRetentionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentRetainPersonalData?.recruitmentRetentionContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentRetainPersonalData?.recruitmentRetentionContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentRetainPersonalData?.recruitmentSecurityIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentRetainPersonalData?.recruitmentSecurityTitleTh
                                    ) : (
                                        recruitmentRetainPersonalData?.recruitmentSecurityTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentRetainPersonalData?.recruitmentSecurityIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentRetainPersonalData?.recruitmentSecurityContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentRetainPersonalData?.recruitmentSecurityContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentDataSubjectRight?.recruitmentDataSubjectRightIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentDataSubjectRight?.recruitmentDataSubjectRightTitleTh
                                    ) : (
                                        recruitmentDataSubjectRight?.recruitmentDataSubjectRightTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentDataSubjectRight?.recruitmentDataSubjectRightIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentDataSubjectRight?.recruitmentDataSubjectRightContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentDataSubjectRight?.recruitmentDataSubjectRightContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentPolicyChange?.recruitmentChangeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentPolicyChange?.recruitmentChangeTitleTh
                                    ) : (
                                        recruitmentPolicyChange?.recruitmentChangeTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentPolicyChange?.recruitmentChangeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentPolicyChange?.recruitmentChangeContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentPolicyChange?.recruitmentChangeContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentPolicyChange?.recruitmentDataControllerIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentPolicyChange?.recruitmentDataControllerTitleTh
                                    ) : (
                                        recruitmentPolicyChange?.recruitmentDataControllerTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentPolicyChange?.recruitmentDataControllerIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentPolicyChange?.recruitmentDataControllerContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentPolicyChange?.recruitmentDataControllerContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {recruitmentPolicyChange?.recruitmentDataProtectionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        recruitmentPolicyChange?.recruitmentDataProtectionTitleTh
                                    ) : (
                                        recruitmentPolicyChange?.recruitmentDataProtectionTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {recruitmentPolicyChange?.recruitmentDataProtectionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            recruitmentPolicyChange?.recruitmentDataProtectionContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            recruitmentPolicyChange?.recruitmentDataProtectionContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {lang === 'TH'
                                    ? 'ฉบับ ณ วันที่'
                                    : 'Edition as of'}{' '}
                                {getCurrentDate(
                                    recruitmentPrivacyPolicy?.effectiveDate
                                )}
                            </h4>
                        </article>
                    </div>
                </div>
            </div>
            <div hidden={!mode}>
                <BackTop style={{ zIndex: 100000 }}>
                    <div
                        className="flex items-center justify-center !bg-[#1890ff]"
                        style={style}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </BackTop>
            </div>
        </Spin>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
